function getWidgetCssHref() {
  const scriptTag = document.querySelector(
    'script[src*="enrollment-widget.js"]'
  ) as HTMLScriptElement | null

  if (!scriptTag) {
    return null
  }

  try {
    const scriptUrl = new URL(scriptTag.src)
    return (
      scriptUrl.origin +
      scriptUrl.pathname.replace(/enrollment-widget\.js$/, 'enrollment-widget.css')
    )
  } catch {
    const base = scriptTag.getAttribute('src')?.replace(/enrollment-widget\.js(\?.*)?$/, '') ?? ''
    return `${base}enrollment-widget.css`
  }
}

export function ensureWidgetStyles(target: ParentNode) {
  const cssHref = getWidgetCssHref()

  if (!cssHref) {
    return
  }

  const existing = target.querySelector(
    `link[rel="stylesheet"][href="${cssHref}"]`
  ) as HTMLLinkElement | null

  if (existing) {
    return
  }

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = cssHref
  target.appendChild(link)
}

export function ensureGooglePlacesStyles() {
  const styleId = 'enrollment-widget-google-places-styles'

  if (document.getElementById(styleId)) {
    return
  }

  const style = document.createElement('style')
  style.id = styleId
  style.textContent = `
    .pac-container {
      font-family: Montserrat, ui-sans-serif, system-ui, sans-serif !important;
      background: #fff !important;
      border: 2px solid #eee !important;
      border-radius: 8px !important;
      margin-top: 4px !important;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
      padding: 4px 0 !important;
      z-index: 99999 !important;
    }

    .pac-container::after {
      display: none !important;
    }

    .pac-item {
      padding: 10px 16px !important;
      font-size: 14px !important;
      font-family: Montserrat, ui-sans-serif, system-ui, sans-serif !important;
      color: #35312d !important;
      cursor: pointer !important;
      border-top: 1px solid #f5f5f5 !important;
      line-height: 1.5 !important;
    }

    .pac-item:first-child {
      border-top: none !important;
    }

    .pac-item:hover,
    .pac-item-selected {
      background-color: rgba(230, 83, 0, 0.08) !important;
    }

    .pac-item-query {
      font-size: 14px !important;
      font-weight: 600 !important;
      color: #35312d !important;
    }

    .pac-matched {
      color: #e65300 !important;
      font-weight: 700 !important;
    }

    .breadcrumbs {
      display: none;
    }
  `

  document.head.appendChild(style)
}

export function isolateWidgetEvents(container: HTMLElement) {
  if (container.dataset.widgetEventsIsolated === 'true') {
    return
  }

  const stopBubble = (event: Event) => {
    event.stopPropagation()
  }

  const eventTypes = [
    'click',
    'dblclick',
    'mousedown',
    'mouseup',
    'mousemove',
    'touchstart',
    'touchend',
    'pointerdown',
    'pointerup',
    'focusin',
    'focusout',
    'input',
    'change',
    'keydown',
    'keyup',
    'submit'
  ] as const

  eventTypes.forEach(type => {
    container.addEventListener(type, stopBubble)
  })

  container.dataset.widgetEventsIsolated = 'true'
}
